import { z } from "zod";
import { AccountType } from "@prisma/client";
import { investorCodeValidation } from "~/globals/shared";

export const emailValidation = z.string().email().trim().min(1).max(100);
const passwordValidation = z.string().trim().min(8).max(55);

function passwordMatchRefine<
  T extends { password: string; passwordConfirmation: string },
>(data: T) {
  return data.password === data.passwordConfirmation;
}

const passwordMatchError = {
  message: "Passwords don't match",
  path: ["passwordConfirmation"],
};
export const formValidationSchemaSignIn = z.object({
  email: emailValidation,
  password: passwordValidation,
});
export type ISchemaSignIn = z.infer<typeof formValidationSchemaSignIn>;

const passwordValidationShape = z.object({
  password: passwordValidation,
  passwordConfirmation: z.string(),
});
const baseShape = z
  .object({
    fullName: z.string().trim().min(1).max(150),
    email: emailValidation,
  })
  .merge(passwordValidationShape);

export const formValidationSchemaSignUp = z
  .discriminatedUnion(
    "accountType",
    [
      z
        .object({ accountType: z.literal(AccountType.STARTUP) })
        .merge(baseShape),
      z
        .object({
          accountType: z.literal(AccountType.INVESTOR),
          investorCode: investorCodeValidation,
          vcName: z.string().trim().min(1).max(150),
        })
        .merge(baseShape),
    ],
    {
      errorMap: () => ({ message: "Please select an account type" }),
    },
  )
  .refine(passwordMatchRefine, passwordMatchError);
export type ISchemaSignUp = z.infer<typeof formValidationSchemaSignUp>;

export const formValidationSchemaForgotPassword = z.object({
  email: emailValidation,
});
export type ISchemaForgotPassword = z.infer<
  typeof formValidationSchemaForgotPassword
>;

export const formValidationSchemaUpdatePassword =
  passwordValidationShape.refine(passwordMatchRefine, passwordMatchError);
export type ISchemaUpdatePassword = z.infer<
  typeof formValidationSchemaUpdatePassword
>;
